module.exports = __webpack_public_path__ + "img/pen-paintbrush.4486e872.svg";